<template>
  <w-flex justify-center align-center v-if="$zutil.role('Pentadbir Sistem')">
    <div class="w-card__content content-hardcode">
        <w-flex class="mt3">
         <div class="xs11 text-right" >
          <w-button dark class="green--bg ml1" @click="add()">
             <w-icon class="mr1">fal fa-plus</w-icon> Tambah
         </w-button>
       </div>
      </w-flex>
    </div>
  </w-flex>
  <div class="w-table-wrap" >
    <table class="w-table" color="light" >
      <thead>
        <tr>
          <th class="w-table__header  text-left" width="1%">No</th>
          <th class="w-table__header  text-left">Tarikh Pengeluaran</th>
          <th class="w-table__header  text-left">No. Batch</th>
          <th class="w-table__header  text-left">ID Ternakan</th>
          <th class="w-table__header  text-left">No Ejakulasi</th>
          <th class="w-table__header  text-left">Isipadu</th>
          <th class="w-table__header  text-left">Skor Keaktifan</th>
          <th class="w-table__header  text-left">% Motiliti</th>
          <th class="w-table__header  text-left">Kepekatan Sperma (/ML)</th>
          <th class="w-table__header  text-left">Jumlah Straw</th>
          <th class="w-table__header  text-left">% Motiliti Sejuk</th>
          <th class="w-table__header  text-left">% Motiliti Beku</th>
          <th class="w-table__header  text-left">Status (P/ML)</th>
        </tr>
      </thead>

      <tbody>
        <template v-if="data.length == 0">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
          </tr>
        </template>
        <template v-for="(dt, ind) in data">
          <tr class="w-table__row" >
            <td class="w-table__cell text-left" >{{ind+1}}</td>
            <td class="w-table__cell text-left" >{{ $zutil.dateformat(dt.tarikh)}}</td>
            <td class="w-table__cell text-left" >{{dt.no_batch}}</td>
            <td class="w-table__cell text-left" >{{dt.ternakan}}</td>
            <td class="w-table__cell text-left" >{{dt.lkp_ejakulasi_label}}</td>
            <td class="w-table__cell text-left" >{{dt.isipadu}}</td>
            <td class="w-table__cell text-left" >{{dt.stor_keaktifan}}</td>
            <td class="w-table__cell text-left" >{{dt.motiliti}}</td>
            <td class="w-table__cell text-left" >{{dt.label_kepekatan_sperma}}</td>
            <td class="w-table__cell text-left" >{{dt.jumlah_straw}}</td>
            <td class="w-table__cell text-left" >{{dt.motiliti_sejuk}}</td>
            <td class="w-table__cell text-left" >{{dt.motiliti_beku}}</td>
            <td class="w-table__cell text-left" >{{dt.status}}</td>
            
          </tr>
        </template>
      </tbody>
    </table>
  </div>



</template>

<script>
export default {
  name: "Pemilik",
  props:{
    data: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'ternakan',
      form : {},
      datas : this.data,
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 800,
      },

      jenis:[
        {value: 1, label: "Normal"},
        {value: 2, label: "Abnormal"}
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      
    }
  },
  methods:{
    
    
  },
      
  mounted() {
    // this.datas = this.data;
  }
}
      

</script>  
